var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
}; // @ts-ignore


import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { Input } from '@progress/kendo-vue-inputs'; // tslint:enable:max-line-length

var TextFilter = {
  name: 'kendoTextFilter',
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return (// @ts-ignore
      h(Input, {
        value: this.$props.filter.value || '',
        attrs: this.v3 ? undefined : {
          value: this.$props.filter.value || ''
        },
        onInput: this.onChange,
        on: this.v3 ? undefined : {
          "input": this.onChange
        }
      })
    );
  },
  methods: {
    onChange: function onChange(event) {
      this.$emit('filterchange', {
        nextFilter: __assign(__assign({}, this.$props.filter), {
          value: event.value
        })
      });
    }
  }
};
var TextFilterVue3 = TextFilter;
export { TextFilter, TextFilterVue3 };